import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Hero from '../components/Hero';
import aboutBannerBg from '../assets/images/AboutUs/AboutUsBanner.webp';
import whoWeAreImg from '../assets/images/AboutUs/Img1.webp';
import teamImg from '../assets/images/AboutUs/Img3.webp';
import customerImg from '../assets/images/AboutUs/Img4.webp';
import techImg from '../assets/images/AboutUs/Img2.webp';

// Styled Components
const SectionTitle = styled.h2`
  font-size: 40px;
  font-weight: 500;
  margin-bottom: 10px;
  line-height: 1.2;
  
  .highlight {
    color: #e4880f;
  }
`;

const SectionSubtitle = styled.p`
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #555;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  margin-bottom: 5px;
`;

const Divider = styled.div`
  width: 100px;
  height: 3px;
  background-color: #e4880f;
  margin: 10px 0 30px;
  
  &.center {
    margin-left: auto;
    margin-right: auto;
  }
`;

const SectionBox = styled.div`
  background-color: ${props => props.bgColor || '#f9f9f9'};
  padding: 50px 40px;
  border-radius: 5px;
  height: 100%;
  
  h3 {
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 20px;
    color: ${props => props.titleColor || '#333'};
  }
  
  p {
    font-size: 15px;
    line-height: 1.6;
    color: ${props => props.textColor || '#555'};
    font-family: 'Montserrat', sans-serif;
  }
`;

const PageNavigation = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  
  a {
    color: #555;
    text-decoration: none;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    
    &:hover {
      color: #e4880f;
    }
  }
  
  span {
    margin: 0 5px;
    color: #555;
  }
`;

const ContactButton = styled(Button)`
  background-color: white;
  color: #333;
  border: 1px solid #e4880f;
  padding: 12px 30px;
  font-weight: 500;
  letter-spacing: 1px;
  border-radius: 0;
  font-size: 14px;
  transition: all 0.3s ease;
  margin-top: 20px;
  text-transform: uppercase;
  
  &:hover {
    background-color: #e4880f;
    color: white;
    border-color: #e4880f;
  }
`;

const About = () => {
  return (
    <>
      {/* Hero Section */}
      <div 
        style={{ 
          backgroundImage: `url(${aboutBannerBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
          height: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          textAlign: 'left'
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            zIndex: 1
          }}
        ></div>
        
        <Container style={{ position: 'relative', zIndex: 2 }}>
          <div style={{ paddingLeft: '15px' }}>
            <h1 style={{ 
              color: 'white', 
              fontSize: '42px', 
              fontWeight: 600, 
              marginBottom: '10px' 
            }}>
              About Us
            </h1>
            <PageNavigation>
              <Link to="/" style={{ color: 'white' }}>Home</Link>
              <span style={{ color: 'white' }}>/</span>
              <span style={{ color: '#e4880f' }}>About Us</span>
            </PageNavigation>
          </div>
        </Container>
      </div>

      {/* Who We Are Section */}
      <section style={{ padding: '80px 20px' }}>
        <Container style={{ width: '80%', maxWidth: '1200px' }} className="mx-auto">
          <Row className="align-items-center">
            <Col lg={6} md={12} className="mb-5 mb-lg-0">
              <div style={{ maxWidth: '90%', margin: '0 auto' }}>
                <img src={whoWeAreImg} alt="Who We Are" className="img-fluid" style={{ borderRadius: '5px', width: '100%' }} />
              </div>
            </Col>
            <Col lg={6} md={12}>
              <div style={{ padding: '0 15px' }}>
                <SectionTitle>
                  Who We <span className="highlight">Are</span>
                </SectionTitle>
                <SectionSubtitle style={{ marginTop: '8px' }}>FABXPERT</SectionSubtitle>
                <div style={{ width: '100px', height: '3px', backgroundColor: '#e4880f', margin: '15px 0 25px 0' }}></div>
                
                <p style={{ 
                  marginBottom: '20px', 
                  fontFamily: 'Montserrat, sans-serif', 
                  lineHeight: '1.8',
                  color: '#333',
                  fontWeight: '400'
                }} className="fs-ss-16">
                  FabXpert provides precision-cutting solutions for industries where accuracy, reliability, and quality 
                  are essential. Whether it's intricate architectural designs, high-performance aerospace components, 
                  or durable parts for manufacturing, our cutting technology ensures exceptional results.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Why Choose FabXpert Section */}
      <section style={{ padding: '0px 0 80px 0', backgroundColor: '#fff' }}>
        <Container style={{ width: '80%', maxWidth: '1200px' }} className="mx-auto">
          <div className="text-center mb-5">
            <SectionTitle style={{ fontWeight: '500' }}>
              Why Choose <span className="highlight">FabXpert?</span>
            </SectionTitle>
            <SectionSubtitle>YOUR CUTTING NEEDS, OUR EXPERT SOLUTIONS</SectionSubtitle>
            <div style={{ width: '120px', height: '3px', backgroundColor: '#e4880f', margin: '15px auto 25px' }}></div>
          </div>
          
          {/* First row: 70% Technology & 30% Quality */}
          <Row className="g-4 mb-4">
            <Col lg={8}>
              <div style={{ 
                padding: '50px 40px', 
                height: '100%',
                backgroundImage: `url(${techImg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                position: 'relative'
              }} className="rounded-5">
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                }} className="rounded-5"></div>
                <div style={{ position: 'relative', zIndex: 2 }}>
                  <h3 style={{ 
                    fontSize: '28px', 
                    fontWeight: '500', 
                    marginBottom: '20px', 
                    color: 'white' 
                  }}>
                    Our Technology & Capabilities
                  </h3>
                  <div className="col-8 me-auto">
                    <p style={{ 
                      lineHeight: '1.8', 
                      color: '#eaeaea',
                      fontFamily: 'Montserrat, sans-serif' 
                    }} className="fs-ss-13">
                      We believe that precision starts with the right tools. That's why we use state-of-the-art machines and advanced CAD/CAM software to ensure unmatched accuracy in every project. Whether it's complex geometries, high-volume production, or custom prototypes, our cutting and engineering capabilities meet the highest industry standards.
                    </p>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={4}>
              <div style={{ 
                backgroundColor: '#e4880f', 
                padding: '50px 40px', 
                height: '100%'
              }} className="rounded-5">
                <h3 style={{ 
                  fontSize: '28px', 
                  fontWeight: '500', 
                  marginBottom: '20px', 
                  color: 'white' 
                }}>
                  Commitment to Quality
                </h3>
                <p style={{ 
                  lineHeight: '1.8', 
                  color: 'white',
                  fontFamily: 'Montserrat, sans-serif' 
                }} className="fs-ss-13">
                  Quality isn't optional—it's the foundation of everything we do. We follow strict quality control processes to ensure durability, precision, and consistency. Every cut, every design, and every project are carefully crafted to meet the highest standards.
                </p>
              </div>
            </Col>
          </Row>
          
          {/* Second row: 30% Team & 70% Customer Approach */}
          <Row className="g-4">
            <Col lg={4}>
              <div style={{ 
                backgroundColor: '#333', 
                padding: '50px 40px', 
                height: '100%',
                backgroundImage: `url(${teamImg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                position: 'relative'
              }} className="rounded-5">
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                }} className="rounded-5"></div>
                <div style={{ position: 'relative', zIndex: 2 }}>
                  <h3 style={{ 
                    fontSize: '28px', 
                    fontWeight: '500', 
                    marginBottom: '20px', 
                    color: 'white'
                  }}>
                    Our Team & Experience
                  </h3>
                  <p style={{ 
                    lineHeight: '1.8', 
                    color: 'white',
                    fontFamily: 'Montserrat, sans-serif'
                  }} className="fs-ss-13">
                    Behind every precise cut is a team of skilled engineers, machinists, and designers who bring years of expertise. Our professionals are committed to delivering high-quality solutions, no matter the scale or complexity of the project.
                  </p>
                </div>
              </div>
            </Col>
            <Col lg={8}>
              <div style={{ 
                backgroundColor: '#333', 
                padding: '50px 40px', 
                height: '100%',
                backgroundImage: `url(${customerImg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                position: 'relative'
              }} className="rounded-5">
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                }} className="rounded-5"></div>
                <div style={{ position: 'relative', zIndex: 2 }}>
                  <h3 style={{ 
                    fontSize: '28px', 
                    fontWeight: '500', 
                    marginBottom: '20px', 
                    color: 'white'
                  }}>
                    Customer-Centric Approach
                  </h3>
                  <div className="col-8 me-auto">
                    <p style={{ 
                      lineHeight: '1.8', 
                      color: 'white',
                      fontFamily: 'Montserrat, sans-serif'
                    }} className="fs-ss-13">
                      We understand that every industry has unique needs. That's why we take a customized approach, working closely with our clients to provide tailored solutions that align with their requirements. From manufacturing and aerospace to architecture and automotive, we ensure every project gets the attention to detail it deserves.
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Partner With FabXpert Section */}
      <section className="pb-5 mb-md-4">
        <Container className="text-center">
          <SectionTitle className="mb-0">
            <span className="dark" style={{ color: '#333' }}>Partner </span>
            <span className="highlight">With FabXpert</span>
          </SectionTitle>
          <SectionSubtitle style={{ color: '#555', marginTop: '10px', marginBottom: '10px' }}>
            LET'S BUILD SOMETHING GREAT
          </SectionSubtitle>
          <div style={{ 
            width: '120px', 
            height: '3px', 
            backgroundColor: '#e4880f', 
            margin: '10px auto 30px' 
          }}></div>
          
          <p style={{ 
            fontSize: '16px', 
            fontFamily: 'Montserrat, sans-serif', 
            lineHeight: '1.6', 
            color: '#555', 
            maxWidth: '800px', 
            margin: '0 auto 25px' 
          }}>
            We're here to help bring your vision to life with precision and expertise.<br />
            Let's discuss how FabXpert can support your next project.
          </p>
          
          <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button 
              style={{ 
                backgroundColor: 'white',
                border: '3px solid #e4880f',
                color: '#333',
                padding: '12px 45px',
                fontWeight: '500',
                letterSpacing: '1px',
                borderRadius: '0',
                fontSize: '14px',
                transition: 'all 0.3s ease',
                boxShadow: '2px 2px 8px rgba(0, 0, 0, 0.2)'
              }}
              className="contact-btn"
              onClick={() => window.location.href='/contact'}
            >
              CONTACT US
            </button>
          </div>
        </Container>
      </section>
    </>
  );
};

export default About; 